
import _ from "lodash";

const ua = navigator.userAgent.toLowerCase();
const isWxClient =
  ua.match(/MicroMessenger/i) == "micromessenger" &&
  ua.match(/wxwork/i) != "wxwork";

const self = {
  state: {
    appName: 'madePlan',
    isWxClient: isWxClient,
    visitorId: "", // 访问者id,永久存储
    sessionId: ""
  },
  getters: {
    appName: state => {
      return state.appName;
    },
    isWxClient: state => {
      return state.isWxClient;
    }
  },
  mutations: {
    SET_SYSVAR(state, { key, value }) {
      var obj = state,
        keys = key.split(".");
      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys.pop()] = value;
    }
  },
  actions: {
    //--
  }
};

export default self;
